var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TwoColumnQuizReviewLayout',{scopedSlots:_vm._u([{key:"responses",fn:function(){return _vm._l((_vm.responses),function(option){return _c('ResponseItem',{key:option.id,class:{
        'correct': option.correct,
        'incorrect': !option.correct,
      },attrs:{"option":option,"showCheckMarkIcon":true,"showOrder":true}})})},proxy:true},{key:"answers",fn:function(){return _vm._l((_vm.answers),function(option){return _c('ResponseItem',{key:option.id,attrs:{"showOrder":true,"option":option,"showCheckMarkIcon":false}})})},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }